export default "__VITE_ASSET__fa579348__"